module.exports = __webpack_public_path__ + "img/UBC.ef60df7b.jpg";